import { Link } from "react-router-dom";
import { PageHeader } from "../components/shell/PageHeader";
import { EmptyState } from "../components/ui/Feedback";

export function NotFound() {
  return (
    <>
      <PageHeader eyebrow="404" title="No such page" />
      <EmptyState
        title="That address does not correspond to anything in this panel."
        detail="It may be from an older version, or a link that was cut short."
        action={
          <Link
            to="/fleet"
            className="text-micro font-semibold uppercase tracking-[0.11em] text-signal underline decoration-1 underline-offset-4 hover:no-underline"
          >
            Go to charge points
          </Link>
        }
      />
    </>
  );
}
